import { Col } from 'antd';
import { useField } from 'formik';
import { useTranslation } from 'react-i18next';
import * as permissionKind from '../../../../../shared/permissions';
import { MaskDirection } from '../../../../api/types';
import { useAccount } from '../../../../components/contexts/AccountContextManager';
import { useCompany } from '../../../../components/contexts/CompanyContextManager';
import FormFields from '../../../../themes/admin/Fields/FormFields';
import hasPermissions from '../../../../utilities/hasPermissions';
import useSystemOptions from '../../../../utilities/useSystemOptions';

const CompanyCustomerDataMaskFields = () => {
    const { t } = useTranslation(['companyDetails']);
    const { maskDirectionOptions, maskCountOptions } = useSystemOptions();

    const [{ value: dataMask }] = useField('dataMask');
    const { permissions: accountPermissions } = useAccount();
    const company = useCompany(true);
    const hasPermission = company
        ? hasPermissions(company.permissions, [permissionKind.updateCompany]) &&
          hasPermissions(accountPermissions, [permissionKind.updateCompany])
        : hasPermissions(accountPermissions, [permissionKind.updateCompany]);

    return (
        <>
            <Col lg={8} xs={24}>
                <FormFields.SelectField
                    {...t('companyDetails:fields.maskDirection', { returnObjects: true })}
                    disabled={!hasPermission}
                    name="dataMask.direction"
                    options={maskDirectionOptions}
                    required
                    showSearch
                />
            </Col>
            {dataMask.direction !== MaskDirection.None && (
                <Col lg={8} xs={24}>
                    <FormFields.SelectField
                        {...t('companyDetails:fields.maskCount', { returnObjects: true })}
                        disabled={!hasPermission}
                        name="dataMask.count"
                        options={maskCountOptions}
                        showSearch
                    />
                </Col>
            )}
        </>
    );
};

export default CompanyCustomerDataMaskFields;
